import React from 'react';
import './HowItWorks.scss';

const STEPS = [
  { num: '01', title: 'Estimate', body: 'Enter your ZIP, hours and trainer count. You see the total cost before creating an account.' },
  { num: '02', title: 'Post', body: 'Publish the job with your rate. Posting is free, and credentialed trainers nearby are notified.' },
  { num: '03', title: 'Confirm', body: 'Review applicants, check licensure and confirm the trainer you want on site.' },
  { num: '04', title: 'Pay after', body: 'The shift is worked, documentation lands in your account, and the total is charged once.' },
];

const HowItWorks = () => (
  <section id="how" className="pl-how">
    <div className="pl-how__inner">
      <div className="pl-how__head">
        <div className="pl-how__eyebrow">How it works</div>
        <h2 className="pl-how__title">From estimate to covered event in four steps</h2>
      </div>
      <div className="pl-how__grid">
        {STEPS.map((s) => (
          <div key={s.num} className="pl-how__step">
            <div className="pl-how__num">{s.num}</div>
            <div className="pl-how__step-title">{s.title}</div>
            <p className="pl-how__step-body">{s.body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
